import * as React from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "./Button";

type Props = {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export default class OkButton extends React.Component<Props> {
    public render(): React.ReactNode {
        const classes = [ "button-ok" ];

        return (
            <Button
                type="button"
                onClick={this.props.onClick}
                classes={classes}
            >
                <FontAwesomeLight icon="thumbs-up" />OK
            </Button>
        );
    }
}
